import type { PlanDefinition } from '@store/api/subscriptionApi'

/** Static plan copy for the public pricing page (API plans require authentication). */
export const MARKETING_PLANS: PlanDefinition[] = [
  {
    name: 'free',
    displayName: 'Free',
    monthlyPrice: 0,
    annualPrice: 0,
    features: [
      'Up to 1 humidor',
      '100 cigar limit',
      'Basic collection tracking',
      'Simple smoking journal',
      'Mobile app access',
      'Community support',
      'Basic analytics',
    ],
  },
  {
    name: 'premium',
    displayName: 'Premium',
    monthlyPrice: 9.99,
    annualPrice: 99.99,
    features: [
      'Unlimited humidors',
      'Unlimited cigars',
      'Advanced collection management',
      'Detailed smoking journal with photos',
      'Advanced analytics and insights',
      'Data export (CSV, JSON)',
      'Priority email support',
      'Collection value tracking',
      'Custom categorization',
      'Batch and box management',
    ],
  },
  {
    name: 'pro',
    displayName: 'Pro',
    monthlyPrice: 19.99,
    annualPrice: 199.99,
    features: [
      'Everything in Premium',
      'Environmental monitoring integration',
      'API access for integrations',
      'Custom reports and analytics',
      'White-label options',
      'Dedicated account manager',
      'Phone and email support',
      'Advanced data import tools',
      'Team collaboration features',
      'Custom branding options',
    ],
  },
]
